/* eslint-disable @typescript-eslint/no-empty-function */
export const noop = () => {};
